import { metaAdsStore } from "./meta-ads.store";
import type { StoreData } from "./meta-ads.store";

type PurchaseData = {
    id: string;
    total: number;
    currency: "SEK";
    item_ids?: string[];
};

function init(id: string) {
    metaAdsStore.update((storeData) => {
        return [
            {
                type: "init",
                event: id,
                data: undefined,
            },
            ...storeData,
        ];
    });
}

function pageView() {
    metaAdsStore.update((storeData) => {
        return [
            ...storeData,
            {
                type: "track",
                event: "PageView",
                data: undefined,
            },
        ];
    });
}

export function addToCart(contents: [{ id: string; quantity: number }]) {
    metaAdsStore.update((storeData) => {
        return [
            ...storeData,
            {
                type: "track",
                event: "AddToCart",
                data: { contents },
            },
        ];
    });
}

export function initiateCheckout(item_ids: string[]) {
    metaAdsStore.update((storeData) => {
        return [
            ...storeData,
            {
                type: "track",
                event: "InitiateCheckout",
                data: { content_ids: item_ids },
            },
        ];
    });
}

function purchase(purchaseData: PurchaseData) {
    metaAdsStore.update((storeData) => {
        const newPurchaseData: StoreData = {
            type: "track",
            event: "Purchase",
            data: { currency: purchaseData.currency, value: purchaseData.total, content_ids: purchaseData.item_ids },
        };
        return [...storeData, newPurchaseData];
    });
}
export const metaAds = {
    init,
    pageView,
    purchase,
};
